import { render, staticRenderFns } from "./HandleResult.vue?vue&type=template&id=f4513d2a&scoped=true"
import script from "./HandleResult.vue?vue&type=script&lang=js"
export * from "./HandleResult.vue?vue&type=script&lang=js"
import style0 from "./HandleResult.vue?vue&type=style&index=0&id=f4513d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4513d2a",
  null
  
)

export default component.exports